import React from "react";

import Card, { CardProps } from "../Card/Card";
import Checkbox, { CustomCheckboxProps } from "../Checkbox/Checkbox";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./CardCheckbox.module.css";

type Props = CustomCheckboxProps & CardProps;

const CardCheckBox: React.FC<Props> = ({
  className,
  children,
  checked,
  onChange,
  label,
  formControlClassName,
  disabled,
}) => {
  return (
    <Card
      className={toClassName(styles.container, className)}
      header={
        <Checkbox
          checked={checked}
          onChange={onChange}
          label={label}
          disabled={disabled}
          formControlClassName={formControlClassName}
        />
      }
    >
      {children}
    </Card>
  );
};

export default CardCheckBox;
